import { isPaysonicHost } from "src/config/deploymentConfig";

export const IS_PAYSONIC = isPaysonicHost();

export const API_URL = IS_PAYSONIC
  ? "https://api.paysonic.network"
  : "https://api.tylt.money";